import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

const sliders = () => {
  new Swiper('.pictures .swiper', {
    modules: [Navigation, Pagination, Autoplay],
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // autoplay: {
    //   delay: 4000
    // },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    // // And if we need scrollbar
    // scrollbar: {
    //   el: '.swiper-scrollbar',
    // },
  });

  let productsSwiperWrapperOptions = {
    modules: [Autoplay],
    slidesPerView: 1,
    direction: 'horizontal',
    loop: true,
    breakpoints: {
      800: {
        slidesPerView: 3
      },
      1000: {
        slidesPerView: 4
      },
    }
  }

  if (!window.matchMedia('(max-width: 965px)').matches) {
    productsSwiperWrapperOptions.autoplay = {
      delaty: 4000
    }
  }

  new Swiper('.products-slider-wrapper .swiper', productsSwiperWrapperOptions);
}

export default sliders;